import { chromeLink } from "@capaj/trpc-browser/link";
import { createTRPCProxyClient } from "@trpc/client";
import { createTRPCReact } from "@trpc/react-query";

import type { AppRouter } from "./router";

export const trpc = createTRPCReact<AppRouter>();

export type ExtensionTrpcClient = ReturnType<
  typeof createTRPCProxyClient<AppRouter>
>;

let client: ExtensionTrpcClient | null = null;

const CHROME_PORT_DISCONNECT_MESSAGES = [
  "Port disconnected prematurely",
  "Attempting to use a disconnected port object",
  "Extension context invalidated",
];

/** True when `chrome.runtime` is available (background, content script, or extension page). */
export function isChromeExtensionRuntime(): boolean {
  return typeof chrome !== "undefined" && Boolean(chrome.runtime?.id);
}

export function isChromePortDisconnectError(error: unknown): boolean {
  const message =
    error instanceof Error
      ? `${error.message}\n${error.stack ?? ""}`
      : String(error);

  return CHROME_PORT_DISCONNECT_MESSAGES.some((disconnectMessage) =>
    message.includes(disconnectMessage),
  );
}

export function getExtensionTrpcClient(): ExtensionTrpcClient {
  if (!isChromeExtensionRuntime() || !chrome.runtime.connect) {
    throw new Error(
      "Chrome extension messaging is not available in this context",
    );
  }

  if (!client) {
    const port = chrome.runtime.connect(undefined, { name: "stitch-panel" });

    const nextClient = trpc.createClient({
      links: [chromeLink({ port })],
    });

    client = nextClient;

    port.onDisconnect.addListener(() => {
      if (client === nextClient) {
        client = null;
      }
    });

    console.log("created trpc client");
  }

  return client;
}
